import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLetterZSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"letter-z-square, key"} maskId="square-filled-radius-0-stroke-1-IconLetterZSquare"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM9.03516 7.77246V8.72168H13.6582V8.81543L8.87109 15.4775V16.2275H15.123V15.2783H10.2598V15.1846L15.0234 8.52246V7.77246H9.03516Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLetterZSquare;
